import getApiUrl from './getApiUrl';

export default (payload) => {
  const apiUrl = getApiUrl();

  return navigator.sendBeacon(`${apiUrl}/api`, JSON.stringify(payload));
};
